// API設定
// 開発環境: http://localhost:3000
// 本番環境: https://rangers-api-3mfw.onrender.com

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rangers-api-3mfw.onrender.com';
